import { ValueColumn } from '@vdms-hq/ui';

/**
 * Shared audit-trail columns (issue #15935 / FD57905) for the Controlled Lists tables — shown at
 * both the Field Type and Value levels. `created_by`/`modified_by` render the minified user's name;
 * `created_by == null` → "Unknown", `modified_by == null` → blank; dates render in the viewer's
 * local timezone (backend sends UTC), blank when null. Display-only (no server-side sort/filter yet).
 */
export const AUDIT_COLUMNS: ValueColumn[] = [
  {
    id: 'created_by',
    label: 'pages.fields.columns.created_by',
    valuePath: 'created_by',
    viewFormat: { modifiers: { valueObjectKey: 'name' }, fallback: 'Unknown' },
  },
  {
    id: 'created_at',
    label: 'pages.fields.columns.created_at',
    valuePath: 'created_at',
    viewFormat: { modifiers: { dateFormat: 'date-time' }, fallback: '' },
  },
  {
    id: 'modified_by',
    label: 'pages.fields.columns.modified_by',
    valuePath: 'modified_by',
    viewFormat: { modifiers: { valueObjectKey: 'name' }, fallback: '' },
  },
  {
    id: 'modified_at',
    label: 'pages.fields.columns.modified_at',
    valuePath: 'modified_at',
    viewFormat: { modifiers: { dateFormat: 'date-time' }, fallback: '' },
  },
];

/**
 * Client-side-sortable variant of {@link AUDIT_COLUMNS} for the Controlled Lists tables backed by a
 * `LocalDataSource` (both `GET /field-types` and `GET /fields` load full data, so sorting happens in
 * memory). Dates sort by their own path; `created_by`/`modified_by` are user objects, so they sort by
 * the resolved name via `sortObjectPath`. Use this only where the datasource is sortable — the plain
 * {@link AUDIT_COLUMNS} stays display-only for tables that are not.
 */
export const AUDIT_COLUMNS_SORTABLE: ValueColumn[] = AUDIT_COLUMNS.map((column) => ({
  ...column,
  sortable: true,
  ...(column.id === 'created_by' ? { sortObjectPath: 'created_by.name' } : {}),
  ...(column.id === 'modified_by' ? { sortObjectPath: 'modified_by.name' } : {}),
}));
